import {PureComponent} from 'react'

import {generate} from '../../routes.js'

import './CookiesBanner.scss'

export default class CookiesBanner extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      cookiesAccepted: false
    }
  }

  componentDidMount() {
    if (document.cookie.split(';').filter((item) => item.includes('cookiesAccepted=1')).length) {
      this.setState({cookiesAccepted: true})
    }
  }

  acceptCookies = () => {
    // Set cookies "cookiesAccepted" for 1 year
    document.cookie = 'cookiesAccepted=1;max-age=31536000;samesite'
    this.props.onCookiesAccepted()
  }

  render() {
    if (this.state.cookiesAccepted) {
      return null
    }

    return (
      <div id="cookies-banner" className="p-2">
        <div id="cookies-banner-content" className="d-md-flex justify-content-md-center" >
          <span>
            En poursuivant votre navigation, vous acceptez le dépôt de cookies tiers
            destinés à améliorer votre expérience de navigation et mesurer l'audience.
          </span>
          <button onClick={this.acceptCookies} className="btn btn-sm btn-light">
            Accepter
          </button>
          <a href={`${generate({name: 'cgu'})}#cookies`}
            target="_blank" rel="noopener noreferrer"
            className="btn btn-sm btn-outline-light">
            En savoir plus
          </a>
        </div>
      </div>
    )
  }
}